import { useEffect, useRef } from "react";
const useFirstResolvedPromise = (promise)=>{
    const hasResolvedRef = useRef(false);
    const currentPromiseRef = useRef(null);
    const resultPromiseRef = useRef(new Promise((resolve)=>{
    // Placeholder promise to ensure the returned promise is consistent
    // This will be replaced with the first resolved promise
    }));
    useEffect(()=>{
        if (hasResolvedRef.current) {
            return ()=>{
            // Silence is golden.
            };
        }
        currentPromiseRef.current = promise;
        promise.then((res)=>{
            if (currentPromiseRef.current === promise && !hasResolvedRef.current) {
                hasResolvedRef.current = true;
                resultPromiseRef.current = Promise.resolve(res);
            }
        }).catch(()=>{
        // Handle promise rejection if needed
        });
        return ()=>{
            // Clean up if the component unmounts or the promise changes
            currentPromiseRef.current = null;
        };
    }, [
        promise
    ]);
    return resultPromiseRef.current;
};
export { useFirstResolvedPromise };
